// mui 5
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";


export const StyledPokemons = styled(Box)(({ theme }) => ({

  // ---DEBUG---
  // border: "2px dashed red",
}));


